import React from "react";
import PropTypes from "prop-types";
import {ActionButton, ButtonWrapper, CloudDownloadIcon, EditIcon} from "./ActionButtons.sc";

const ActionButtons = (props) => {

    const {handleOnClickGenerate, handleDownload, loadingComplete, downloadAvailable, showDownloadButton} = props;

    return (
        <ButtonWrapper>
            <ActionButton
                variant={"contained"}
                onClick={handleOnClickGenerate}
                disabled={!loadingComplete}>
                Generate
                <EditIcon/>
            </ActionButton>
            {
                showDownloadButton &&
                <ActionButton
                    variant={"contained"}
                    onClick={handleDownload}
                    disabled={!downloadAvailable}>
                    Download
                    <CloudDownloadIcon/>
                </ActionButton>
            }
        </ButtonWrapper>
    );

};

ActionButtons.propTypes = {
    downloadAvailable: PropTypes.bool.isRequired,
    loadingComplete: PropTypes.bool.isRequired,

    handleDownload: PropTypes.func.isRequired,
    handleOnClickGenerate: PropTypes.func.isRequired,

    showDownloadButton: PropTypes.bool.isRequired
};

export default ActionButtons;



// WEBPACK FOOTER //
// ./src/common/ActionButtons/ActionButtons.js